// export action types
import { ADD_URLS } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - payload object (data to dispatch)
 * @desc Returns action object for **TYPE_SOME_EVENT** event
 * @returns {object} - Redux action object
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { addUrls } from 'actions/addUrls';
 *
 * // dispatch action
 * store.dispatch( addUrls( payload ) );
 */
export const addUrls = ( payload ) => {
    return {
        type: ADD_URLS,
        payload: payload
    };
};
